<div class="pinned-card-wrapper">
  @if (pinnedItem?.model_name === PinnedModels.Note) {
    <app-note-card
      class="pinned-note-card"
      [note]="pinnedItem?.content_object"
      [isPinned]="true"
      [disableClick]="disableClick"
    ></app-note-card>
  }

  @if (pinnedItem?.model_name === PinnedModels.Job) {
    <div class="jobs-card">
      <div class="title">
        <div class="message-card-header">
          <i class="tio-briefcase"></i>
          <span>Job</span>
        </div>
      </div>
      <div class="card-content" style="margin-bottom: -15px">
        <app-jobs-and-tasks-card
          class="pinned-note-card"
          (click)="selectJob()"
          [job]="pinnedItem?.content_object"
        ></app-jobs-and-tasks-card>
      </div>
    </div>
  }

  @if (pinnedItem?.model_name === PinnedModels.TrackedItem) {
    <div class="jobs-card">
      <div class="title">
        <div class="message-card-header">
          <i class="feather check-circle"></i>
          <span>Client Task</span>
        </div>
      </div>
      <div class="card-content">
        <tracked-item-bubble
          class="pinned-note-card"
          [tracked_item]="pinnedItem?.content_object"
          [company]="getClientCompany()"
          [conversation]="{ id: pinnedItem?.content_object.conversation }"
          [shouldOpenDrawer]="true"
        ></tracked-item-bubble>
      </div>
    </div>
  }

  @if (pinnedItem?.model_name === PinnedModels.Message) {
    <div class="jobs-card" (click)="selectMessage()">
      <div class="title">
        <div class="message-card-header">
          <svg
            style="top: 10px"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15.0001 14.9998C15.8841 14.9998 16.732 14.6486 17.3571 14.0235C17.9822 13.3984 18.3334 12.5506 18.3334 11.6665V4.99984C18.3334 4.11578 17.9822 3.26794 17.3571 2.64281C16.732 2.01769 15.8841 1.6665 15.0001 1.6665H5.00008C4.11603 1.6665 3.26818 2.01769 2.64306 2.64281C2.01794 3.26794 1.66675 4.11578 1.66675 4.99984V17.9165C1.66675 18.027 1.71065 18.133 1.78879 18.2111C1.86693 18.2893 1.97291 18.3332 2.08341 18.3332C2.13791 18.3329 2.1918 18.3216 2.24189 18.3002C2.29198 18.2787 2.33727 18.2474 2.37508 18.2082L4.87508 15.7082C5.11203 15.4775 5.39239 15.2961 5.69994 15.1745C6.00749 15.0529 6.3361 14.9935 6.66675 14.9998H15.0001Z"
              fill="#959DAB"
            />
          </svg>
          <span>Client Message</span>
        </div>
      </div>
      <div class="card-content">
        <div class="message-card-bubble">
          <div class="message-header">
            <span class="message-username">{{
              pinnedItem?.content_object?.content?.sent_by?.full_name
            }}</span>
            <span class="message-time">{{
              pinnedItem?.content_object?.content?.date
                | amCalendar: moment_calendar_format
            }}</span>
            <ds-pin
              [hovering]="true"
              [type]="pinnedItem?.model_name"
              [identifier]="pinnedItem?.content_object.uuid"
              [model]="pinnedItem?.content_object"
              [pin]="pinnedItem"
              [additionalAttributes]="{
                conversationUuid:
                  dashboardStore.currentCompany.company_conversation.uuid,
              }"
              [company]="{
                id: dashboardStore.currentCompany.id,
                uuid: pinnedItem?.client_company,
              }"
            />
          </div>
          <div class="message-content">
            {{ pinnedItem?.content_object.content.message }}
          </div>
        </div>
      </div>
    </div>
  }

  @if (pinnedItem?.model_name === PinnedModels.Thread) {
    <div class="jobs-card">
      <div class="title">
        <div class="message-card-header">
          <i class="tio-inbox"></i>
          <span>Email</span>
        </div>
      </div>
      <div class="card-content">
        <email-card
          [isPinned]="true"
          [pin]="pinnedItem"
          [email]="pinnedItem?.content_object"
        ></email-card>
      </div>
    </div>
  }
</div>
